module.exports = "/dist/assets/images/rx-login.svg";